import { ApplicationState } from 'app/store/store'

export const getDelegateUserId = (
  state: ApplicationState,
): string | undefined => state.auth.delegateUserId
